import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _indexOf from 'lodash/indexOf';

import formatDuration from './formatDuration';

export default function($window, $q) {
    'ngInject';

    var service = {
        arrayDiff: arrayDiff,
        arrayDeepPropDiff: arrayDeepPropDiff,
        valByStr: valByStr,
        confirmSimple: confirmSimple,
        isBrowserFirefox: isBrowserFirefox,
        getClosestParentElem: getClosestParentElem,
        parseOptions: parseOptions,
        findFirstEl: findFirstEl,
        getAllFormEls: getAllFormEls,
        addOrConditionToAttribute: addOrConditionToAttribute,
        findResource: findResource,
        replaceResource: replaceResource,
        getSectionResource: getSectionResource,
        resourceNotFoundMessage: {
            header: 'Error: Not Found',
            body: 'Item not found'
        },
        getItemName: getItemName,
		convertMsToMinutesSeconds: formatDuration
    };

    // elements that exist in A but not in B
    function arrayDiff(arrayA, arrayB) {
        return arrayA.filter(function(i) {
            return arrayB.indexOf(i) < 0;
        });
    }

    // get diff between two arrays containing objects
    // based on a nested object property
    function arrayDeepPropDiff(arrayA, arrayB, accessString) {
        return _filter(arrayB, function(refObj) {
            return !_find(arrayA, function(selectedObj) {
                return valByStr(selectedObj, accessString) === valByStr(refObj, accessString);
            });
        });
    }

    // dataObj      data: {profile: {displayName: 'test'}}
    // keyStr       'data.profile.displayName'
    // returns      'test'
    function valByStr(dataObj, keyStr) {
        var keyArr = keyStr.split('.');
        var getValueRec = function(currObj, next) {
            next = next || 0;
            if (keyArr.length !== next) {
                currObj = currObj[keyArr[next]];
                next++;
                return getValueRec(currObj, next);
            } else {
                return currObj;
            }
        };
        return getValueRec(dataObj);
    }

    function confirmSimple(message) {
        /*eslint-disable */
        return confirm(message);
        /*eslint-enable */
    }

    function isBrowserFirefox() {
        return $window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }

    // finds closest element of a type for an angular element
    function getClosestParentElem(childEl, parentElType) {
        var getElemRec = function(currEl) {
            if (!currEl[0]) {
                return null;
            } else if (currEl[0].localName !== parentElType) {
                return getElemRec(currEl.parent());
            }  else {
                return currEl;
            }
        };
        return getElemRec(childEl.parent());
    }

    // makes hash out of options string such as "formName:plupp;attachTo:biff;"
    function parseOptions(optsString) {
        var opts = {};
        optsString.split(';').forEach(function(opt) {
            if (opt) {
                opts[opt.split(':')[0]] = opt.split(':')[1];
            }
        });
        return opts;
    }

    function findFirstEl(containerEl, elemTypeList) {
        var firstFoundElem;
        var i = 0;
        var current;
        while (!firstFoundElem) {
            current = containerEl.find(elemTypeList[i]);
            if (current.length > 0) {
                firstFoundElem = current;
            } else {
                i++;
            }
        }
        return firstFoundElem;
    }

    function getAllFormEls(formElem) {
        var foundEls = [];
        ['input', 'textarea', 'select', 'button'].forEach(function(elType) {
            foundEls = foundEls.concat(Array.prototype.slice.call(formElem.find(elType)));
        });
        return foundEls;
    }

    // element is the DOM element, not angular.element
    // attributeName without prefix "data-"
    function addOrConditionToAttribute(element, attributeName, orCondition) {
        var $elem = angular.element(element);
        var previousAttributeVal = $elem.attr('data-' + attributeName) || $elem.attr(attributeName);
        $elem.removeAttr('data-' + attributeName).removeAttr(attributeName);
        var newAttributeVal = previousAttributeVal ? previousAttributeVal + ' || ' + orCondition : orCondition;
        $elem.attr('data-' + attributeName, newAttributeVal);
    }

    function findResource(list, resId) {
        return $q(function(resolve, reject) {
            var foundResource = _find(list, function(listItem) {
                return listItem.data.id === resId;
            });
            if (foundResource) {
                resolve(foundResource);
            } else {
                reject(service.resourceNotFoundMessage);
            }
        });
    }

	function getSectionResource(list, sectionPropValue, sectionPropName) {
		return list.find(entry => entry.data.section && entry.data.section[sectionPropName] && entry.data.section[sectionPropName] === sectionPropValue);
	}

    function replaceResource(list, replacementObj) {
        return $q(function(resolve, reject) {
            var foundResource = _find(list, function(listItem) {
                return listItem.data.id === replacementObj.data.id;
            });
            if (foundResource){
                var index = _indexOf(list, foundResource);
                list.splice(index, 1, replacementObj);
                resolve();
            } else {
                //list.push(replacementObj); // Unknown resId - should we add the replacementObj to list instead?
                reject();
            }
        });
    }

	function getItemName(itemType, itemList, itemId, fallback) {
        var item = _find(itemList, { data: { id: itemId }});
        if (item) {
            switch (itemType) {
                case 'user':    return item.data.profile.displayName;
                case 'group':   return item.data.name;
                case 'case':    return item.data.name;
            }
        } else {
            return fallback || '-';
        }
    }

    return service;
};
